import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { URL } from '@/utils/url';
const { brand, sessionid, baseURL } = URL;
const retryProps = {
  retriesCount: 3,
  excludedStatusCodes: [401, 404],
};

interface Options {
  url: string;
  customHeaders?: any;
  payload?: Object;
}

const getHeaders = (customHeaders: any) => {
  return {
    headers: {
      ...customHeaders,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      token: 'xxxx',
    },
  };
};

axios.defaults.baseURL = '';
axios.defaults.timeout = 50000;

//Generic Request Interceptor Code
const requestInterceptor = (req: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  return req;
};

//Generic Response Interceptor Code
const successInterceptor = (res: AxiosResponse): AxiosResponse => {
  return res;
};

//Generic Exception Code
const errorInterceptor = (err: AxiosError) => {
  return Promise.reject(err);
};

axios.interceptors.request.use(requestInterceptor);
axios.interceptors.response.use(
  (res: any) => successInterceptor(res),
  (err: any) => errorInterceptor(err)
);

const get = (route: string, baseUrl = baseURL): Promise<AxiosResponse> => {
  console
  return new Promise((resolve, reject) => {
    const url = `${baseUrl}${route}`;
    const defHeaders = {
      brand: brand.toLowerCase(),
      sessionid: sessionid,
    };
    axios
      .get(url, getHeaders(defHeaders))
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
};

const retry: any = async (fn: any, relatedTo: string, retriesLeft = retryProps.retriesCount) => {
  try {
    return await fn();
  } catch (error: any) {
    console.log(`fail to fetch data related to ${relatedTo} trying to re-fetch ...`);
    if (retriesLeft === 0 || retryProps.excludedStatusCodes.includes(error.response?.status)) {
      console.log(
        `ERROR: unable to fetch data related to ${relatedTo}, even after multiple retries`
      );
      throw error;
    }
    const backoffTime = 2 ** (retryProps.retriesCount - retriesLeft) * 1500;
    await new Promise((resolve) => setTimeout(resolve, backoffTime));
    console.log(`retries count on fetching data related to ${relatedTo} is: ${retriesLeft}`);
    return retry(fn, relatedTo, retriesLeft - 1); // Retry the request
  }
};

export { get, retry };
